__turbopack_context__.v({
  "alert": "Alert-module__x6A2Ka__alert",
  "container": "Alert-module__x6A2Ka__container",
  "dismiss": "Alert-module__x6A2Ka__dismiss",
  "fadeOut": "Alert-module__x6A2Ka__fadeOut",
});
